import React from 'react';
import axios from "axios";
import { useState } from "react";

function Recovery() {
  const [content, setContent] = useState({
    username: "",
    email: "",
  });
  const handleClick = () => {
    alert("El proceso de seguimiento ha comenzado");
    axios
      .post("https://ferias-ingenio-backend.vercel.app/api/users/recovery", content)
      .then((res) => {
      })
      .catch((err) => {
        if (err) console.log(err);
      });
  };
  return (
    <div>
      <h1>Recuperación de cuentas</h1>
      <p>
        Esta pagina es para realizar seguimiento de las cuentas que han sido
        detectadas como multicuentas.
      </p>
      <p>
        Llene el formulario y presiona el boton para darle seguimiento a la
        cuenta y ver lo que sucede con la cuenta.
      </p>
      <input
        type="text"
        placeholder="Correo"
        value={content.email}
        onChange={(e) => {
          setContent({ ...content, email: e.target.value });
        }}
      />
      <input
        type="text"
        placeholder="Usuario"
        value={content.username}
        onChange={(e) => {
          setContent({ ...content, username: e.target.value });
        }}
      />
      <button onClick={handleClick}>Dar Seguimento</button>
    </div>
  );
}

export default Recovery;
